import { FormattedMessage } from 'react-intl';
import { InView } from 'react-intersection-observer';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Alert from '../components/UI/Alert';
import ButtonLink from '../components/UI/ButtonLink';
import Project from '../components/Project';
import Title from '../components/UI/Title';
import realisations from '../assets/data/realisations';
import updateUrlInView from '../services/updateUrlInView';
import { renderSpan } from '../services/renderValues';

/**
 * ## Showcase all personal realisations i made
 * @returns
 */
function Realisations() {
  const navigate = useNavigate();

  return (
    <>
      <section className="text-left text-sm-center" id="title">
        <Title titleSection level={1}>
          <FormattedMessage
            id="realisation.title"
            values={
              {
                span: renderSpan,
              } as Record<string, any>
            }
          />
        </Title>
      </section>

      <main className="main-content">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <Alert>
                <FormattedMessage id="realisation.info" />
              </Alert>
            </div>
            <div className="col-12">
              {realisations.map((realisation) => (
                <InView
                  key={realisation.id}
                  threshold={0.5}
                  id={realisation.shortname}
                  onChange={(inView) => updateUrlInView(navigate, inView, realisation.shortname)}
                >
                  <Project project={realisation} />
                </InView>
              ))}
            </div>
            <br />
            <ButtonLink link="/parler" icon="btnContact">
              <FormattedMessage id="menu.contact.longname" />
            </ButtonLink>
          </div>
        </div>
      </main>
    </>
  );
}

export default Realisations;
